import React, { useState } from "react";
import { Select } from "antd";
import styles from "./BodyshopPotential.module.css";

const data = {
  Luxury: {
    "City A": {
      collision_rate: 0.72,
      per_car_labour: 45000,
      per_car_sales: 85000,
    },
    "City B": {
      collision_rate: 0.6,
      per_car_labour: 45000,
      per_car_sales: 85000,
    },
    "City C": {
      collision_rate: 0.48,
      per_car_labour: 35000,
      per_car_sales: 100000,
    },
    "City D": {
      collision_rate: 0.36,
      per_car_labour: 35000,
      per_car_sales: 100000,
    },
  },
  "Mass Market": {
    "City A": {
      collision_rate: 0.84,
      per_car_labour: 14000,
      per_car_sales: 9000,
    },
    "City B": {
      collision_rate: 0.72,
      per_car_labour: 12500,
      per_car_sales: 9000,
    },
    "City C": {
      collision_rate: 0.6,
      per_car_labour: 11500,
      per_car_sales: 12000,
    },
    "City D": {
      collision_rate: 0.48,
      per_car_labour: 11500,
      per_car_sales: 14000,
    },
    "City E": {
      collision_rate: 0.36,
      per_car_labour: 11500,
      per_car_sales: 14000,
    },
  },
};

function formatIndian(value) {
  function format(num) {
    return parseFloat(num.toFixed(3)).toString();
  }
  if (value >= 10000000) return format(value / 10000000) + "Cr";
  if (value >= 100000) return format(value / 100000) + "L";
  if (value >= 1000) return format(value / 1000) + "K";
  return value.toString();
}

export default function BodyshopPotential() {
  const [brand, setBrand] = useState("");
  const [city, setCity] = useState("");
  const [service, setService] = useState("");
  const [error, setError] = useState("");
  const [results, setResults] = useState(null);
  const [buttonText, setButtonText] = useState("Calculate Your Potential");

  const resetStateOnInput = () => {
    setButtonText("Calculate Your Potential");
    setResults(null);
    setError("");
  };

  const isDisabled =
    !brand ||
    !city ||
    service === "" ||
    isNaN(parseInt(service, 10)) ||
    parseInt(service, 10) < 0 ||
    (brand === "Luxury" && city === "City E");

  const calculate = () => {
    setError("");
    setResults(null);

    const serviceNum = parseInt(service, 10);

    if (isNaN(serviceNum) || serviceNum < 0) {
      setError("Please enter a valid service number.");
      return;
    }

    if (brand === "Luxury" && city === "City E") {
      setError("🚫 Luxury brand is not available in City E.");
      return;
    }

    const annualLoad = serviceNum * 12;
    const divisor = brand === "Luxury" ? 2.3 : 2.2;
    const units = Math.round(annualLoad / divisor);
    const vars = data[brand][city];

    const repairs = Math.round((vars.collision_rate * units) / 12);
    const labour = repairs * vars.per_car_labour;
    const parts = repairs * vars.per_car_sales;

    setResults({
      repairs,
      labour: formatIndian(labour),
      parts: formatIndian(parts),
    });

    setButtonText("Your Bodyshop Business Potential");
  };

  return (
    <div
      className={styles["calculator-page"]}
      style={{
        backgroundImage: "url('/img/bodyshop-potential.jpg')",
      }}
    >
      <div
        className={`${styles.container} ${
          results ? styles.containerWithResults : ""
        }`}
      >
        <h2>Bodyshop Potential Calculator</h2>

        <label htmlFor="brand">Car Brand Type</label>
        <Select
          id="brand"
          placeholder="Select your Brand Type"
          value={brand || undefined}
          onChange={(value) => {
            setBrand(value);
            resetStateOnInput();
          }}
          style={{ width: "100%" }}
          className={styles.antSelect}
          options={[
            { value: "Luxury", label: "Luxury" },
            { value: "Mass Market", label: "Mass Market" },
          ]}
        />

        <label htmlFor="city">City Category</label>
        <Select
          id="city"
          placeholder="Select a city"
          value={city || undefined}
          className={styles.antSelect}
          onChange={(value) => {
            setCity(value);
            resetStateOnInput();
          }}
          style={{ width: "100%" }}
          options={[
            { value: "City A", label: "City A" },
            { value: "City B", label: "City B" },
            { value: "City C", label: "City C" },
            { value: "City D", label: "City D" },
            { value: "City E", label: "City E" },
          ]}
        />

        <label htmlFor="service">
          Monthly average Service (All types) + BP Load of past six months
        </label>
        <input
          type="number"
          id="service"
          min="0"
          placeholder="Enter a number"
          value={service}
          onChange={(e) => {
            setService(e.target.value);
            resetStateOnInput();
          }}
        />

        <button
          onClick={calculate}
          disabled={isDisabled}
          aria-disabled={isDisabled}
        >
          {buttonText}
        </button>

        {brand === "Luxury" && city === "City E" && (
          <div className={styles.error}>
            🚫 Luxury brand is not available in City E.
          </div>
        )}
        {error && <div className={styles.error}>{error}</div>}

        {results && (
          <div id="results">
            <div className={styles["result-box"]}>
              Repairs Per Month: {results.repairs}
            </div>
            <div className={styles["result-box"]}>
              Labour Revenue: ₹{results.labour}
            </div>
            <div className={styles["result-box"]}>
              Parts Sales Per Month: ₹{results.parts}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
